import { Button } from '@mui/material';
import React, { useState } from 'react';

import { getComparator, stableSort } from '../components/utilities';
import LeadersPlayerStatItem from './playerStatItem';
import { getFieldName } from './fieldMapping';
import '../coach_style.css';

const LeadersPlayerStatColumn = ({ list, title, option, isTotal, onClick, t }) => {
    const [isFull, setIsFull] = useState(false);

    // Helper to calculate average for a player
    const calcAverage = (player) => {
        const gamesPlayed = parseFloat(player.total_player_games) || 0;
        if (gamesPlayed === 0) return 0;

        const totalFieldName = getFieldName(option, true);
        let totalValue = parseFloat(player[totalFieldName]) || 0;

        // Special case for saved: add super_save
        if (option === 'saved') {
            totalValue += parseFloat(player['total_super_save']) || 0;
        }

        return totalValue / gamesPlayed;
    };

    // For totals: sort/filter by the total field directly
    // For averages: calculate average from total / games_played
    const property = getFieldName(option, true); // Always use total field for base value

    let processedList;
    if (isTotal) {
        const sortedList = stableSort(list, getComparator('desc', property));
        processedList = sortedList.filter((item) => {
            const value = option === 'saved'
                ? (parseFloat(item[property]) || 0) + (parseFloat(item['total_super_save']) || 0)
                : parseFloat(item[property]) || 0;
            return value !== 0;
        });
    } else {
        // Sort by calculated average
        const sortedList = [...list].sort((a, b) => calcAverage(b) - calcAverage(a));
        processedList = sortedList.filter((item) => calcAverage(item) !== 0);
    }

    const filteredList = processedList;

    return (
        <div style={{ width: '100%', borderRadius: '8px', border: '1px solid #E8E8E8', justifyContent: 'space-between', display: 'flex', flexDirection: 'column' , marginBottom: '20px'}}>
            <div>
                <div style={{ width: '100%', height: '40px', borderRadius: '8px', background: '#17375E', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p className="leaders-column-title">{t(title)}</p>
                </div>
                <div style={{ 
                    maxHeight: '530px', 
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
                className="hide-scrollbar">
                    {(isFull ? filteredList : filteredList.slice(0, 5)).map((item, index) => (
                        <LeadersPlayerStatItem key={index} player={item} option={option} isTotal={isTotal} onShow={onClick} />
                    ))}
                </div>
            </div>
            {!isFull && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '10px',marginBottom: '10px' }}>
                    <Button variant="contained" sx={{ background: '#5C738E', '&:hover': { background: '#17375E' }, width: '50%', height: '36px', fontSize: '0.7rem' }} onClick={() => setIsFull(true)}>
                        Full List
                    </Button>
                </div>
            )}
        </div>
    );
};

export default LeadersPlayerStatColumn;
